import { render, staticRenderFns } from "./promote.vue?vue&type=template&id=78e05e00&"
import script from "./promote.vue?vue&type=script&lang=js&"
export * from "./promote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports